const SUMMARY_URL = process.env.API_URL + '/health/summary';
const XUGARHERO_ACCESSIBLE_USERS = process.env.API_URL + '/xugarhero/accessibleUsers';

const getAccessibleUsers = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(XUGARHERO_ACCESSIBLE_USERS)
      .then(response => {
        const body = response.body;
        const models = body.map(model => { return { id: model.accessibleUserId, label: model.username }; });
        resolve(models);
      }, error => {
        reject(error);
      });
  });
};

const getSummary = (context, timestampFrom, numDays, userIdExplore) => {
  return new Promise((resolve, reject) => {
    context.$http.get(SUMMARY_URL, {
      params: {
        timestampFrom: timestampFrom,
        numDays: numDays,
        userIdExplore: userIdExplore
      }
    })
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getSummary,
  getAccessibleUsers
};



// WEBPACK FOOTER //
// ./src/brand/health/api/summary/index.js